import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import OrdersEntity from '@/entities/api/orders/orders'

interface NotificationsState {
	unreadCount: number
	notifiedOrders: OrdersEntity[]
	notifiedActive?: boolean
}

const initialState: NotificationsState = {
	unreadCount: 0,
	notifiedOrders: [],
	notifiedActive: true,
}

const notificationsSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		addNotificationOrder: (state, action: PayloadAction<OrdersEntity>) => {
			const exists = state.notifiedOrders.some(
				(order) => order._id === action.payload._id
			)
			if (!exists) {
				state.notifiedOrders.unshift(action.payload)
				state.unreadCount += 1
			}
		},

		markAllAsRead: (state) => {
			state.unreadCount = 0
		},

		removeNotificationOrder: (state, action: PayloadAction<string>) => {
			state.notifiedOrders = state.notifiedOrders.filter(
				(order) => order._id !== action.payload
			)
		},

		clearNotifications: (state) => {
			state.notifiedOrders = []
			state.unreadCount = 0
		},

		toggleNotifiedActive: (state) => {
			state.notifiedActive = false
		},
	},
})

export const {
	addNotificationOrder,
	markAllAsRead,
	removeNotificationOrder,
	clearNotifications,
	toggleNotifiedActive,
} = notificationsSlice.actions

export default notificationsSlice.reducer
